import React, { useMemo } from 'react';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { SecurityDataEditorProps } from './SecurityDataEditor.props';
import { useCashFlowContext } from '../context/CashFlowContext';
import { fromEntityValue } from '../data/entityValue';
import { CashFlowLedgerTableData } from '../data/types';

const SecurityDataEditor = (props: SecurityDataEditorProps) => {
  const { cell } = props;
  const { allowedSecurityOptionsByEntity } = useCashFlowContext();

  // Find the entity cell in the same row
  const entityCell = useMemo(
    () =>
      Object.values(cell.sheet?.cells ?? {}).find(
        c => c.alias === 'entity' && c.rowNumber === cell.rowNumber
      ),
    [cell.sheet?.cells, cell.rowNumber]
  );

  // Acquired-alias rows resolve to the cap table company, so they pick from its securities
  const entityId = fromEntityValue(
    entityCell?.value,
    (cell.sheet?.tableData as CashFlowLedgerTableData | undefined)?.companyId
  )?.entity_company;

  // Offer only fund-ownership securities for the selected entity, or across
  // all entities if no entity is selected
  const securityOptions = useMemo(() => {
    if (entityId && allowedSecurityOptionsByEntity[entityId]) {
      return allowedSecurityOptionsByEntity[entityId];
    }
    return Object.values(allowedSecurityOptionsByEntity).flat();
  }, [entityId, allowedSecurityOptionsByEntity]);

  return <GridSelect menuPosition="fixed" usePortal options={securityOptions} {...props} />;
};

export default SecurityDataEditor;
